import { ID } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { checkPermissionMiddleware } from '../../../permissions/middlewares/checkPermissionMiddleware.js';
import { Permission } from '../../../permissions/roles.js';
import { throttleMiddleware } from '../../../request-middlewares/throttelMiddleware.js';
import { resolveSendSuSUpdateLink } from '../server/resolveSendSuSUpdateLink.js';

/**
 * Mails a guardian the link to correct a running application, optionally with a deadline that declines the
 * application if it stays unanswered. Returns the address it went to.
 */
export const sendSuSUpdateLink = registerMutation({
  operationName: 'sendSuSUpdateLink',
  type: () => String,
  params: [
    { type: () => ID, name: 'childID' },
    { type: () => ID, name: 'guardianID' },
    { type: () => Boolean, name: 'withDeadline' },
  ],
  middlewares: [checkPermissionMiddleware(Permission.VIEW_SUS_INTERVIEW_DATA), throttleMiddleware(2000)],
  resolve: resolveSendSuSUpdateLink,
});
